export const ACTIONS:any = {
	DELETE: 'delete',
	MARK_AS_SENT: 'sent',
	MARK_AS_APPROVED: 'approved',
	MARK_AS_REJECTED: 'rejected',
	EMAIL: 'email',
	WHATSAPP: `whatsapp`,
	SHARE_LINK:'share_link',
	CONVERT_TO_QUOTATION: 'convert-to-quotation',
	CONVERT_TO_INVOICE: 'convert-to-invoice'
}

